// 🔐 Fixed Admin Login Credentials
// These credentials allow only admin to access /admin/dashboard

export const ADMIN_EMAIL = "admin@apnaswad.com";
export const ADMIN_PASSWORD = "ApnaSwad@12345";

